import accountType from "@/types/account";


export function initialAccount(): accountType {
  return {
    id: 0,
    first_name: "",
    last_name: "",
    first_name_kana: "",
    last_name_kana: "",
    email: "",
    email_verified_at: null,
    officeable_type: "",
    officeable_id: 0,
    group_id: null,
    role_id: 1,
    id_external_asp: "",
    pass_external_asp: "",
    login_times: 0,
    comment: "",
    created_by: null,
    updated_by: null,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    status: 1,
    pwd_last_updated_at: "",
    password: "",
    pwd_expiration: "",
    no_email: false,
    temporary_email: "",
    lang: "ja",
    authority_id: null,
    driver_id: "",
    department_id: null,
    telephone_number: null,
    sub: "",
    synced_at: "",
    enabled_driver_mode: true,
    department_target_name: "",
    department_target_id_for_customer: "",
    full_name: "",
    department: null,
    enabled_factory_setting_account: false,
    account_notification_setting: {
      id: 0,
      account_id: 0,
      risky_driving_alerts: {
        "steep_turn": true,
        "rapid_acceleration": true,
        "rapid_deceleration": true
      },
      cvr_upload_alerts: {
        "completed": true
      },
      temperature_alerts: {
        "low_battery": true,
        "sensor_disabled": true
      },
      output_data_alerts: {
        "completed": true
      },
      created_at: "",
      updated_at: "",
    }
  };
}
